import React from 'react'
import Chart from './Chart'

function ChartCard({data}) {

  return (
    <div className='bg-n-1 gap-2  dark:bg-back-darksecondary pt-5 rounded-lg flex flex-row shadow-md border border-n-1/50'>
 <Chart Data={data}  />
     <div className="p-2 w-[13rem] flex items-center justify-center flex-col"> <h2 className='text-tcolor-6 dark:text-tcolor-3 text-md font-kufi font-semibold'>
        {data?.label}
      </h2>
      <h2 className='text-tcolor-5 dark:text-tcolor-2  text-[60px] font-kufi font-semibold'>
        {data?.value}
      </h2>
      
      </div>
     
    </div>
  )
}

export default ChartCard